var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2685 73.8369C57.1557 73.8369 73.2773 57.699 73.2773 37.7919C73.2773 17.8847 57.1557 1.74683 37.2685 1.74683C17.3814 1.74683 1.25977 17.8847 1.25977 37.7919C1.25977 57.699 17.3814 73.8369 37.2685 73.8369Z",
    fill: "#6148AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9853 54.5791C55.4213 41.3456 22.9436 48.3939 17.2637 67.9564C18.8657 68.9633 20.4678 69.9702 22.2155 70.8332C22.6524 70.8332 22.9436 70.6894 23.2349 70.4017C30.3713 61.6273 45.5178 55.1544 56.8777 58.1751C60.0818 59.0382 63.7228 60.9081 66.6356 60.3328C67.9464 58.6067 69.2571 56.7367 70.2766 54.7229C70.131 54.5791 70.1309 54.5791 69.9853 54.5791Z",
    fill: "#8165C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0985 35.4215C63.1798 34.2539 70.8098 30.8969 72.2771 26.8101C70.8098 22.1396 68.4621 17.9069 65.234 14.258C65.0873 14.258 63.4733 12.6525 63.4733 12.3606C59.805 8.56577 55.2564 5.64668 50.1209 3.74927C50.4143 7.69005 49.6806 11.9227 48.947 15.5716C48.0666 19.6584 46.0124 22.2855 43.3713 24.4749C40.7301 25.6425 37.9423 26.5182 35.3011 27.248C28.5515 29.4373 21.6553 31.4807 15.0524 33.816C9.62341 35.8594 4.48782 38.6325 1.25977 43.0111C1.84669 46.806 3.02055 50.4549 4.63458 53.8118C5.36823 53.8118 5.95512 53.5199 6.39531 52.7901C11.3841 42.5733 25.3235 39.3623 35.5946 38.6325C43.8115 38.0487 52.1751 38.3406 60.0985 35.4215Z",
    fill: "#8165C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M35.3231 1.74683C16.2359 3.06604 1.25977 18.7501 1.25977 38.0986C1.25977 49.6783 6.69229 60.0855 15.2081 66.8282C34.2954 65.5089 49.2715 49.8249 49.2715 30.4764C49.2715 18.8966 43.839 8.48948 35.3231 1.74683Z",
    fill: "#D3D6F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlanet);
export default __webpack_public_path__ + "static/media/big-planet.6cf56c2780304dfc635c86c2a4e4aee6.svg";
export { ForwardRef as ReactComponent };